namespace Matrix.Workflow {
    export class ClientFunctionTriggerColumns {
        static columnsKey = 'Workflow.ClientFunctionTrigger';
    }
}
